import {initWebComponent} from "@/helpers/web-component-helper";
import {clearBuffer, measureBuffer} from "@/helpers/measure/measure-buffer-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {getArea, getLength} from "ol/sphere";
import {WKT} from "ol/format";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";

export class LayerInfoInfoItemGeometryMeasureBufferComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');

        template.innerHTML = `<div class="row">
                       <div class="col-6 mt-2">Grootte van buffer</div>
                       <div class="col-6">
                           <div class="input-group">
                              <input type="text" class="form-control" placeholder="0">
                              <span class="input-group-prepend">
                                <span class="input-group-text pl-2 pr-2">m</span>
                              </span>
                              <span class="input-group-append">
                                <button class="btn btn-xs btn-default" data-type="show" type="button">Laat zien</button>
                                <button class="btn btn-xs btn-default d-none" data-type="remove" type="button">Verberg</button>
                              </span>
                            </div>
                        </div>
                    </div>`

        initWebComponent(this, template)

        this.querySelector('input').addEventListener('keyup', (e) => {
            this.querySelector('button[data-type="show"]').classList.remove('d-none')
            this.querySelector('button[data-type="remove"]').classList.add('d-none')
        })

        this.addEventListener('click', (e) => {

            if(!e.target.getAttribute('data-type')) {
                return
            }

            if(e.target.getAttribute('data-type') === 'remove') {
                this.querySelector('button[data-type="show"]').classList.remove('d-none')
                this.querySelector('button[data-type="remove"]').classList.add('d-none')
                this.querySelector('input').value = ''
            } else {
                this.querySelector('button[data-type="remove"]').classList.remove('d-none')
                this.querySelector('button[data-type="show"]').classList.add('d-none')
            }

            const buffer = this.querySelector('input').value

            window.measureOlFeature = window.measureOlFeatureDefault

            if (!buffer) {
                hideElementsBySelector('.measureBuffer')
                clearBuffer()
                return
            }

            let feature = window.measureOlFeature.clone()
            const geometry = feature.getGeometry().transform(feature.get('kv_projection'), getViewProjectionName())

            console.log('measrureeee ')

            const features = measureBuffer(geometry, buffer)

            if (!features) {
                hideElementsBySelector('.measureBuffer')
                return
            }

            window.measureOlFeature = features[0]

            const olGeometry = features[0].getGeometry()

            const surface = olGeometry.getArea().toFixed(2)
            const outline = getLength(olGeometry).toFixed(2)

            const format = new WKT()
            const wkt = format.writeGeometry(olGeometry);

            getBySelector('.measureSurface').innerHTML = surface
            getBySelector('.measureOutline').innerHTML = outline
            getBySelector('.measureWkt').value = wkt

            showElementsBySelector('.measureBuffer')
        })
    }
}

